import { render, staticRenderFns } from "./LiaisonNotification.vue?vue&type=template&id=8b237056&scoped=true"
import script from "./LiaisonNotification.vue?vue&type=script&lang=ts"
export * from "./LiaisonNotification.vue?vue&type=script&lang=ts"
import style0 from "./LiaisonNotification.vue?vue&type=style&index=0&id=8b237056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b237056",
  null
  
)

export default component.exports